import { render, staticRenderFns } from "./DesignPanel.vue?vue&type=template&id=35de3bff&scoped=true&"
import script from "./DesignPanel.vue?vue&type=script&lang=js&"
export * from "./DesignPanel.vue?vue&type=script&lang=js&"
import style0 from "./DesignPanel.vue?vue&type=style&index=0&id=35de3bff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35de3bff",
  null
  
)

export default component.exports